export const getId = () => {
  return `${+new Date()}-${(Math.random() * 100000).toFixed(0)}`
}
